export const environment = {
    production: false,
    apiurl: 'https://securpro-api.dev.olualinet.ao',
    nifApiUrl: 'https://securpro-api.dev.olualinet.ao/api/nif',
    corsPolicy: 'QualCors'
};
